var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{staticClass:"loading-wrap"},[_c('div',{staticClass:"app-toast"},[_c('b-spinner',{staticClass:"ml-2",staticStyle:{"width":"4.5rem","height":"4.5rem"},attrs:{"label":"Large Spinner"}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }